import { useState } from "react";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

export function RemoveUsinaModals(props: {
  onConfirmRemoveUsina: () => Promise<void>;
  showRemoveUsinaModal: boolean;
  setShowRemoveUsinaModal: (value: boolean) => void;
  usinaName: string;
  onMount: () => void;
}) {
  const {
    onConfirmRemoveUsina,
    showRemoveUsinaModal,
    setShowRemoveUsinaModal,
    usinaName,
    onMount,
  } = props;
  const [showRemoveUsinaSuccesModal, setShowRemoveUsinaSuccessModal] =
    useState<boolean>(false);
  const [showRemoveUsinaErrorModal, setShowRemoveUsinaErrorModal] =
    useState<boolean>(false);
  return (
    <>
      <ConfirmationModal
        contentText={`Deseja realmente remover a usina ${usinaName} ?`}
        open={showRemoveUsinaModal}
        onConfirm={onConfirmRemoveUsina}
        setOpen={setShowRemoveUsinaModal}
        title="Remover Usina"
        setOpenErrorModal={setShowRemoveUsinaErrorModal}
        setOpenSuccessModal={setShowRemoveUsinaSuccessModal}
      />
      <ActionAlert
        message="A usina foi removida com sucesso"
        severity="success"
        open={showRemoveUsinaSuccesModal}
        setOpen={setShowRemoveUsinaSuccessModal}
        onClose={() => {
          setShowRemoveUsinaModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao remover a usina do usuário"
        severity="error"
        open={showRemoveUsinaErrorModal}
        setOpen={setShowRemoveUsinaErrorModal}
        onClose={() => {
          setShowRemoveUsinaModal(false);
        }}
      />
    </>
  );
}
